import { useMemo } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { CalendarGuide } from 'pages/tours/tours-calendar-page/components/calendar-guide'

import { DateRangePicker, IRange } from 'widgets/tour/date-range-picker'

import { getNightsText } from 'entities/tour/libs/getNightsDateText.ts'
import calendarTourStore from 'entities/tour/models/calendar-tour/calendar-tour'
import searchTour from 'entities/tour/models/search-tour/search-tour'

import { maxMonthToursCalendar } from 'shared/constants/tours'
import { prepareDate } from 'shared/lib/calendarDateUtils'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const firstIndex = 0

const initialPrices = {
  all: [],
  by_nights: {},
  schedules: null,
}

const ToursCalendarPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const formSearch = searchTour.getEditableDataForSearchTour()
  const dataTour = searchTour.getDataTour()
  const storePrices = calendarTourStore.getPrice()
  const isFlexibleDate = searchTour.getIsFlexibleDate()
  const isFlexibleNights = searchTour.getIsFlexibleNights()

  const prices = storePrices || initialPrices

  const handleFlexibleDate = (value: boolean) => {
    searchTour.setIsFlexibleDate(value)
  }

  const selectedDate: IRange = {
    startDate: formSearch?.flight?.startDay,
  }

  const availableDates = useMemo(() => {
    if (!prices?.schedules)
      return dataTour?.checking?.available_dates?.map((date) =>
        prepareDate(date),
      )

    return prices?.schedules?.map((date) => prepareDate(date))
  }, [prices?.schedules])

  const onGoBack = () => {
    navigate(-1)
  }

  const nightsText = getNightsText({
    t,
    nights: formSearch?.duration,
    isFlexibleNights,
  })

  return (
    <div className={s.container}>
      <div className={s.contentPop}>
        <DateRangePicker
          typeCalendar="tour"
          difficult
          indexDirection={firstIndex}
          selectedDate={selectedDate}
          activeDays={availableDates}
          focusDate={availableDates?.[0]}
          maxMonth={maxMonthToursCalendar}
          header={
            <HeaderGoBack
              buttonWhite
              onGoBack={onGoBack}
              variant="grey"
              title={t('tours_block.select_date')}
            />
          }
          isFlexibleDeparture={isFlexibleDate}
          onFlexibleDate={handleFlexibleDate}
          onSubmit={() => navigate(-1)}
          nightsText={nightsText}
        />
        <CalendarGuide />
      </div>
    </div>
  )
})

export default ToursCalendarPage
